import { useEffect, useMemo } from "react";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { Route, Routes } from "react-router-dom";

import { buildTheme } from "./theme/theme";
import { vfCssVariablesResolver } from "./theme/cssVariablesResolver";
import { applyChrome, useUiStore } from "./stores/uiStore";
import LiveRoot from "./roots/LiveRoot";
import DevRoot from "./roots/DevRoot";

export default function App() {
  const palette = useUiStore((s) => s.palette);
  const density = useUiStore((s) => s.density);

  // The palette lives in the Mantine theme so cssVariablesResolver can emit it;
  // the data attributes let plain CSS (density, first paint) key off it too.
  useEffect(() => {
    applyChrome(palette, density);
  }, [palette, density]);

  const theme = useMemo(() => buildTheme(palette), [palette]);

  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={vfCssVariablesResolver}
      defaultColorScheme="dark"
      forceColorScheme="dark"
    >
      <ModalsProvider>
        <Notifications position="bottom-right" zIndex={500} />
        <Routes>
          {/* Static-data mount: every screen, no backend, no credentials. */}
          <Route path="/dev/*" element={<DevRoot />} />
          <Route path="/*" element={<LiveRoot />} />
        </Routes>
      </ModalsProvider>
    </MantineProvider>
  );
}
